import { ChangeEvent } from 'react';
import {
  TextField,
  Grid,
  InputAdornment,
  SelectChangeEvent,
  FormControlLabel,
  Checkbox,
  Button,
} from '@mui/material';
import FrequencySelect from '../../components/FrequencySelect';
import { InvalidEntryFlags, MonitorForm } from './types';

interface Props {
  monitor: MonitorForm;
  handleMonitorChanged: (
    event:
      | SelectChangeEvent<string>
      | ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    checked?: boolean
  ) => void;
  invalidEntryFlags: InvalidEntryFlags;
  handleCloneMonitorClicked: () => Promise<void>;
  disabled?: boolean;
}

const MonitorSettingsForm = ({
  monitor,
  handleMonitorChanged,
  invalidEntryFlags,
  handleCloneMonitorClicked,
  disabled,
}: Props) => {
  return (
    <Grid container spacing={1} style={{ paddingTop: '5px' }}>
      <Grid item xs={12}>
        <TextField
          id='name'
          name='name'
          label='Name'
          value={monitor?.name}
          variant='outlined'
          size='small'
          onChange={handleMonitorChanged}
          disabled={disabled}
        />
      </Grid>
      <Grid item xs={6}>
        <TextField
          id='beginFrequencyValue'
          name='beginFrequencyValue'
          label='Begin'
          value={monitor?.beginFrequencyValue}
          variant='outlined'
          size='small'
          onChange={handleMonitorChanged}
          error={invalidEntryFlags.begin}
          disabled={disabled}
        />
      </Grid>
      <Grid item xs={6}>
        <FrequencySelect
          selected={monitor?.beginFrequencyUnit}
          name='beginFrequencyUnit'
          onChange={handleMonitorChanged}
          disabled={disabled}
        />
      </Grid>
      <Grid item xs={6}>
        <TextField
          id='endFrequencyValue'
          name='endFrequencyValue'
          label='End'
          value={monitor?.endFrequencyValue}
          variant='outlined'
          size='small'
          onChange={handleMonitorChanged}
          error={invalidEntryFlags.end}
          disabled={disabled}
        />
      </Grid>
      <Grid item xs={6}>
        <FrequencySelect
          selected={monitor?.endFrequencyUnit}
          name='endFrequencyUnit'
          onChange={handleMonitorChanged}
          disabled={disabled}
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          type='number'
          id='upperbound'
          name='upperbound'
          label='Upperbound'
          value={monitor?.upperbound}
          variant='outlined'
          size='small'
          onChange={handleMonitorChanged}
          InputProps={{
            endAdornment: <InputAdornment position='end'>dBm</InputAdornment>,
          }}
          error={invalidEntryFlags.upperbound}
          disabled={disabled}
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          type='number'
          id='lowerbound'
          name='lowerbound'
          label='Lowerbound'
          value={monitor?.lowerbound}
          variant='outlined'
          size='small'
          onChange={handleMonitorChanged}
          InputProps={{
            endAdornment: <InputAdornment position='end'>dBm</InputAdornment>,
          }}
          error={invalidEntryFlags.lowerbound}
          disabled={disabled}
        />
      </Grid>
      <Grid item container>
        <Grid item>
          <FormControlLabel
            name='warning'
            control={
              <Checkbox
                onChange={handleMonitorChanged}
                checked={!!monitor?.warning}
                name='warning'
                disabled={disabled}
              />
            }
            label='Warning Mode'
          />
        </Grid>
        <Grid item>
          <Button
            onClick={handleCloneMonitorClicked}
            disabled={!!monitor?.warning || disabled}
            variant={'contained'}
          >
            Create Clone in Warning Mode
          </Button>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default MonitorSettingsForm;
